const React = require('react');
const ButtonBase = require('@material-ui/core/ButtonBase').default;


module.exports = (props) => {
  const {
    onChange,
    checked,
    disabled,
    error,
  } = props;
  return (
    <div className={`rlv o50.disabled CheckboxD `
      + (error ? 'error ' : '')
      + (disabled ? 'disabled ' : '')
      + (props.className || '')}
    >
      <div className="layoutRow fhaS fvaC">
        <div className="layoutRow fhaS fvaC wmax320">
          <div
            className="rlv sq(|min)32 layoutRow fhaC fvaC bs bc5B47FF b1 r9 ov
              bcF00<.CheckboxD.error
            "
          >
            {checked ? (<div
              className="sq(|min)26 bg5B47FF r8"
            />) : null}
            {disabled ? null : (
              <ButtonBase
                className="dB*2 abs*2 s-5"
                component="div"
                centerRipple
                onClick={() => {
                  onChange && onChange(!checked);
                }}
              />
            )}
          </div>
          <div
            className="f12 fw3 lh18 lts0em pl12 c0"
          >{props.label}</div>
        </div>
      </div>
      {
        error ? (<div className="rlv">
          <div
            className="abs sh25 st f11 cF00 fw4"
          >{props.helperText || 'Obligatory field'}</div>
        </div>) : null
      }
    </div>
  );
};
